import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpMakeDecisionFail implements ICommand
{

	public GameID : number = 0;
	public Error : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readUint53();
		this.Error = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		ba.writeUint8(this.Error);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpMakeDecisionFail();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'Error(B)='+this.Error+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50042;
	}

	public getCmdName() : string
	{
		return 'SpMakeDecisionFail';
	}

}
